import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import parts from '../utilities/parts';
import Helmet from 'react-helmet';

import WorkerInfoApi from '../services/workers/workerInfo/WorkerInfoApi';
import WorkerInfoService from '../services/workers/workerInfo/WorkerInfoService';
import CompanyService from '../services/Companies';
import { PrimeCCUSPreviewService } from '../services/PrimeCCUSPreview'; // ユーザー情報API
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import WorkersApi from '../services/workers/WorkersApi';

import { Description } from '../components/Description';
import Confirmation from '../components/modals/common/Confirmation';
import Information from '../components/modals/common/Information';
import CommonModal from '../components/modals/common/Modal';
import { WorkerTab } from '../components/worker/tab/WorkerTab';
import { WorkerInfo } from '../components/worker/page/WorkerInfo';
import { WorkerImage } from '../components/worker/page/WorkerImage';
import { WorkerSafetyBasicInfo } from '../components/worker/page/WorkerSafetyBasicInfo';
import { JobLicense } from '../components/worker/page/JobLicense';
import { InsuranceInfo } from '../components/worker/page/InsuranceInfo';
import { Anamneses } from '../components/worker/page/Anamneses';
import { MedicalExamination } from '../components/worker/page/MedicalExamination';
import { UrgencyContact } from '../components/worker/page/UrgencyContact';
import { TrainingCommendation } from '../components/worker/page/TrainingCommendation';
import { CcusConnectingDialog } from '../components/modals/CcusConnectingDialog';
import { MasterPageHeader } from '../components/PageHeader';

import masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import { extractErrorMessage } from '../utilities/commonUtil';
import { setWaitTime } from '../utilities/commonUtil';
import {
  isNullOrUndefinedOrEmptyStr,
  replaceTagInErrorMessage,
  safariOnIosCheck,
} from '../utilities/stringUtil';
import {
  WORKER_TAB,
  SEX_TYPE,
  DATE_TIME_FORMAT,
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  STATUS_CODE,
  TIME_OUT_TWO_SECOND,
  CCUS_WORKER_DATA_FETCH_FLG,
  CCUS_SYNCED_STATUS,
  RESIDENT_SIXTEEN_AGE,
  RANK_CONSISTENCY_STATUS,
  ZENDESK_URL_GUIDE,
} from '../utilities/constants';
import _urlParamManager from '../utilities/urlParamManager';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import {
  getTabNameWorkerTabId,
  getIdWorkerTabTabName,
} from '../utilities/constantsUtil';
import { isOneOwnerCompany } from '../utilities/partnerCompanyUtil';
import EventMg, { EventType } from '../utilities/EventManager';

import styles from '../styles/componentStyle/workerForm/workerForm.scss';
import '../styles/componentStyle/worker/page.css';
import { isPartnerRoleId } from '../utilities/roleUtility';
import dialogLoader from '../utilities/dialogLoader';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { isCcusJigyousyaNotConnectedError } from '../utilities/apiErrorMessage';

/**
 * 作業員登録 画面
 * 作業員編集 画面
 * 画面遷移
 *  1.  自社作業員一覧>>新規作成
 *  2.  自社作業員一覧>>データ行選択
 *  3.  自社作業員一覧>>データ行選択>>編集ボタン
 *
 * @props {string}workerId:作業員ID (新規作成時はundefined)
 * @props {object}pageStatus:ページ情報 (新規・詳細・編集)
 * @props {string}selectedTabId:表示中のタブID
 */
export class WorkerForm extends React.Component {
  constructor(props) {
    super(props);

    if (isNullOrUndefinedOrEmptyStr(props.selectCompanyId)) {
      throw new Error('WorkerForm.jsx sessionSelectedPartnerCompanyId');
    }

    if (
      [WORKER_PAGE_STATUS.CONFIRM, WORKER_PAGE_STATUS.EDIT].includes(
        props.pageStatus
      )
    ) {
      if (isNullOrUndefinedOrEmptyStr(props.workerId)) {
        throw new Error('WorkerForm.jsx constructor props.workerId');
      }
    } else if (props.pageStatus === WORKER_PAGE_STATUS.NEW) {
      if (!_.isUndefined(props.workerId)) {
        throw new Error('WorkerForm.jsx constructor props.workerId');
      }
    } else {
      throw new Error('WorkerForm.jsx constructor props.pageStatus');
    }

    const partnerCompanyIdOfPrimeCompany = SessionStorageService.getSessionPartnerCompanyIdOfPrimeCompany();
    const isAgencyRegister =
      props.selectCompanyId !== partnerCompanyIdOfPrimeCompany;

    this.state = {
      // ログイン中ユーザーの権限
      roleId: LocalStorageService.getRoleId(),

      // 会社選択にて選択された協力会社名
      selectCompanyName: null,
      ccusJigyousyaId: null,

      workerInfo: {
        // 作業員基本情報データ用プロパティ (APIと連携する時に必要なプロパティ)
        id: null, // 作業員ID (APIから返ってくる作業員IDを格納する)
        company_id: null, // 会社ID
        name_sei: null, // 作業員(姓)
        name_mei: null, // 作業員(名)
        fullname: null, // 作業員(姓名)
        name_sei_kana: null, // 作業員(姓)カナ
        name_mei_kana: null, // 作業員(名)カナ
        fullname_kana: null, // 作業員(姓名)カナ
        sex: SEX_TYPE.Man.Code, // 性別 (初期値は男性とする)
        birthday: null, // 誕生日
        ccus_engineer_id: null, // CCUSID
        security_code: '', // セキュリティコード (空文字でないとWorkerInfoForm.jsxの方でConsole Errorが表示される)
        ccus_error_code: null, // CCUS連携時にエラーがあった場合のCCUSから返されたエラーコード
        ccus_error_message: null, // CCUS連携時にエラーがあった場合のCCUSから返されたエラーメッセージ
        ccus_synced_status: CCUS_SYNCED_STATUS.UNSET, // CCUS連携ステータス
        age: 0, // 年齢（API通信には必要ない）
        isOverSixteen: false, // 16歳以上か？
        rank_consistency_status: null,
      },
      informationModal: {
        // インフォメーションモーダル用プロパティ (ボタン1つ)
        title: null, // モーダルダイアログのタイトル
        message: null, // モーダルダイアログのメッセージ
        buttonText: null, // モーダルダイアログのボタンのタイトル
      },
      fetchCcusObject: {
        // CCUS技能者情報取得確認用プロパティ (APIと連携する時に必要なプロパティ)
        ccusStateManagementsId: null, // CCUS連携管理ID
        ccusEngineerId: null, // CCUSID
        companyId: null, // 会社ID
        workerId: null, // 作業員ID
        ccusWorkerDataFetchFlg: CCUS_WORKER_DATA_FETCH_FLG.ON.ID, // CCUSマスター情報取得フラグ（CCUSから情報取得ボタンはCCUS技能者情報を設定するので、1固定）
      },
      ccusWorker: {
        rank_name_code: null,
      },
      selectedTabId: props.selectedTabId, // 表示中のタブID
      dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
      dialogConfirmMoveTabId: null, // 編集画面でタブを遷移する時にタブIDを一時保存しておく
      showWorkerName: false, // 作業員名を表示するかどうか
      isAlreadyCcusConnect: false, // 詳細・編集時にCCUS連携済みかどうか
      isCcusJigyousyaConnected: false, // CCUS事業者が連携されているかどうか
      isAgencyRegister, // 代行登録かどうか？ ( true: 代行登録 false: 自社作業員 )
      isOneOwnerCompany: false,
      totalWorker: 0,
      agencyInfo: {},
      isLinkedUser: false,
      roanToChoseiFlg: false, // 労安からの遷移先が直接「作業員詳細」か、黒メニュー「作業員一覧」経由かを区別するフラグ
    };
    this.fetchCcusWorkersDataFlag = false; // 多重取得防止Flag
    this.userId = LocalStorageService.getUserId();
    this.state.roanToChoseiFlg = this.isDirectRoanFlg();
  }

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    let state = { ...this.state };

    await CompanyService.show(this.props.selectCompanyId).then(response => {
      if (response.result) {
        const company = response.data.entities.company;
        state.selectCompanyName = company.name;
        state.ccusJigyousyaId = company.ccus_jigyousya_id;
        state.isOneOwnerCompany = isOneOwnerCompany(company.one_owner_flag);
      }
    });

    const basicInfo = await PrimeCCUSPreviewService.getBasicInfo(
      this.props.selectCompanyId
    );
    if (basicInfo.result) {
      const ccus_company_admin_id = _.get(
        basicInfo.data.entities,
        'ccus_company_admin.id'
      );
      // BLDE_V2-50623 CCUS事業者IDを取得する
      const ccus_jigyousya_id = _.get(
        basicInfo.data.entities,
        'ccus_jigyousya_id'
      );
      if (ccus_jigyousya_id) {
        state.isCcusJigyousyaConnected = true;
      }
      if (ccus_company_admin_id) {
        // CCUS連携ユーザーを取得
        const listUsersInfo = await PrimeCCUSPreviewService.getListUsersInfo(
          this.props.selectCompanyId,
          { ccus_company_admin_id: ccus_company_admin_id }
        );
        if (listUsersInfo.result) {
          // 操作ユーザーが連携ユーザー一覧に存在するかチェック
          const userList = listUsersInfo.data.entities.ccus_company_admins;
          const isLinkedUser = _.some(
            userList,
            user => user.user_id === this.userId
          );
          state.isLinkedUser = isLinkedUser;
        }
      }
    }
    const agencyInfo = await PrimeCCUSPreviewService.getAgencyInfo(
      this.props.selectCompanyId
    );
    if (agencyInfo.result) {
      state.agencyInfo = agencyInfo.data.entities.agency_info;
    }

    if (isNullOrUndefinedOrEmptyStr(this.props.workerId) === true) {
      if (state.isOneOwnerCompany) {
        this.setTotalWorkers();
      }
      this.setState(state);
      return;
    }

    state = await this.fetchWorkerInfo(state);
    this.setState(state);
  }

  /**
   * 労務安全から直接遷移してきたかどうかを判定する
   * @return {boolean} true:労安側から直接作業員詳細への遷移, false:黒メニューの作業員一覧からの遷移
   */
  isDirectRoanFlg = () => {
    let judgement = false;
    if (SessionStorageService.getRoanToChoseiFlg()) {
      // セッションに判定フラグが格納されている場合
      judgement = true;
      SessionStorageService.removeRoanToChoseiFlg();
      _urlParamManager.removeUrlParam('roanToChoseiFlg');
    }
    return judgement;
  };

  setTotalWorkers = async () => {
    const response = await WorkersApi.list(this.props.selectCompanyId, {
      offset: 0,
      limit: 2,
      include_blocked: 'false',
    });
    if (response.result) {
      this.setState({ totalWorkers: _.get(response, 'data.total') || 0 });
    }
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 作業員一覧画面に遷移する
   */
  moveToWorkerList = () => {
    masterSlideLoader.show('Workers', { state: {} });
  };

  /**
   * 作業員詳細ページへ
   */
  moveToWorkerConfirm = () => {
    masterSlideLoader.show('WorkerConfirm', {
      state: {
        id: `${getTabNameWorkerTabId(this.state.selectedTabId)},${
          this.props.workerId
        }`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * 『X』ボタンをクリックした時の処理
   * 登録・編集画面時にはダイアログを表示する
   * 詳細画面時には作業員一覧へ戻る
   * */
  handlerMoveToBackPage = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showCancelEditDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        if (this.state.roanToChoseiFlg) {
          masterSlideLoader.close();
          break;
        } else {
          this.moveToWorkerList();
          break;
        }
      default:
        break;
    }
  };

  /**
   * 登録・編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    this.setState({ dialogStatus: DIALOG_STATUS.cancelEditDialogEnabled.id });
  };

  /**
   * 編集をやめるダイアログで前のページに戻る時の処理
   */
  handlerBackToPage = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
        this.moveToWorkerList();
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        if (this.state.roanToChoseiFlg) {
          masterSlideLoader.close();
          break;
        } else {
          this.moveToWorkerConfirm();
          break;
        }
      default:
        break;
    }
  };

  /**
   * CCUS技能者情報取得
   * */
  fetchCcusWorkersData = () => {
    let state = { ...this.state };
    const params = WorkerInfoService.createRefetchCcusWorkerInfoParam(
      state.workerInfo.id,
      this.props.selectCompanyId
    );

    if (
      isNullOrUndefinedOrEmptyStr(state.workerInfo.ccus_engineer_id) === false
    ) {
      // 重複実行防止処理
      if (this.fetchCcusWorkersDataFlag) {
        return;
      }
      this.setFetchCcusWorkersDataFlag(true);
      state.dialogStatus = DIALOG_STATUS.ccusConnectingDialogEnabled.id;
      this.setState(state);
      WorkerInfoApi.refetchCcusInfo(params)
        .then(response => {
          if (
            (_.has(response.data, 'result') &&
              response.data.result === false) ||
            (_.has(response, 'result') && response.result === false)
          ) {
            this.showErrorMessageDialog(response);
          } else {
            const ccus_engineer_id = _.get(response, 'data.entities.ccus_engineer_id');
            if (isNullOrUndefinedOrEmptyStr(ccus_engineer_id)) {
              // この処理の時点でccus_engineer_id が消えているという状態は同時操作などにより、
              // CCUS連携エラーで消されたパターンしかありえないためエラーメッセージを表示させるためにダイアログを出しリロードを行う。
              this.closeDialog();
              return dialogLoader.show(FormInformationDialog, {
                title: messageUtility.getMessage('E-000-032'),
                message: messageUtility.getMessage('E-000-082'),
                onClose: () => {
                  window.location.reload();
                },
              });
            }
            state.fetchCcusObject.ccusStateManagementsId =
              response.data.entities.ccus_state_management_id;
            state.fetchCcusObject.ccusEngineerId = ccus_engineer_id;
            state.fetchCcusObject.companyId = this.props.selectCompanyId;
            state.fetchCcusObject.workerId = state.workerInfo.id;
            this.setState(state);
            this.monitoringFetchCcusWorkersData()
              .then(response => {
                if (
                  isNullOrUndefinedOrEmptyStr(response) === false &&
                  parts.isEmptyObject(response) === false &&
                  response.status === STATUS_CODE.ok
                ) {
                  //問題なく成功した場合
                  //CCUS情報更新完了モーダル表示
                  this.showCcusFetchCompleteDialog();
                } else {
                  // 入って来ることはないはずだが、何かあった時用 (CCUSローディングダイアログを非表示にする)
                  this.closeDialog();
                }
              })
              .catch(error => {
                this.showErrorMessageDialog(error);
              });
          }
        })
        .catch(error => {
          this.showErrorMessageDialog(error);
        });
    }
  };

  /**
   * CCUS連携を監視する
   * */
  monitoringFetchCcusWorkersData = async () => {
    let state = { ...this.state };
    const params = WorkerInfoService.createCcusMonitoringParam(
      state.fetchCcusObject
    );
    await setWaitTime(TIME_OUT_TWO_SECOND);
    return new Promise((resolve, reject) => {
      WorkerInfoApi.fetchCcusInfo(params).then(response => {
        if (
          (_.has(response.data, 'result') && response.data.result === false) ||
          (_.has(response, 'result') && response.result === false)
        ) {
          reject(response);
        } else {
          if (response.status === STATUS_CODE.accepted) {
            state.fetchCcusObject.ccusStateManagementsId =
              response.data.entities.ccus_state_management_id;
            state.fetchCcusObject.ccusEngineerId =
              response.data.entities.ccus_engineer_id;
            state.fetchCcusObject.workerId = state.workerInfo.id;
            this.setState(state);

            // ステータスコードが処理中(202)の場合
            // 再度現場情報取得状況を監視する
            this.monitoringFetchCcusWorkersData()
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          } else if (response.status !== STATUS_CODE.ok) {
            reject(response);
          } else {
            resolve(response);
          }
        }
      });
    });
  };

  /**
   * 作業員情報を取得する
   * */
  fetchWorkerInfo = async state => {
    await WorkerInfoApi.fetchWorkerInfo(
      this.props.selectCompanyId,
      this.props.workerId
    ).then(response => {
      if (response.result) {
        state.workerInfo = Object.assign(
          state.workerInfo,
          response.data.entities
        );
        state.ccusWorker.rank_name_code = _.get(
          response.data,
          'entities.ccus_worker.rank_name_code'
        );
        state.ccusWorker.rank_name_code &&
          (state.ccusWorker.rank_name_code = Number(
            state.ccusWorker.rank_name_code
          ));

        if (
          this.props.pageStatus === WORKER_PAGE_STATUS.EDIT &&
          state.workerInfo.ccus_synced_status === CCUS_SYNCED_STATUS.DONE.ID
        ) {
          state.isAlreadyCcusConnect = true;
        }

        if (isNullOrUndefinedOrEmptyStr(state.workerInfo.birthday) === false) {
          state.workerInfo.birthday = moment(
            new Date(state.workerInfo.birthday).toISOString()
          ).format(DATE_TIME_FORMAT.slashDateFormat);
          state.workerInfo.age = moment().diff(
            state.workerInfo.birthday,
            'years'
          );
          state.workerInfo.isOverSixteen =
            state.workerInfo.age >= RESIDENT_SIXTEEN_AGE;
        }

        if (
          isNullOrUndefinedOrEmptyStr(state.workerInfo.name_sei) === false &&
          isNullOrUndefinedOrEmptyStr(state.workerInfo.name_mei) === false
        ) {
          state.showWorkerName = true;
        }
      }
    });

    return state;
  };

  /**
   * CCUS技能者取得に完了したダイアログを表示する
   * CCUS連携失敗時にCCUS連携失敗モーダルを表示する
   * */
  showCcusFetchCompleteDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.ccusFetchCompleteDialogEnabled.id,
      informationModal: {
        ...this.state.informationModal,
        title: null,
        message: messageUtility.getMessage('I-002-076-01'),
        buttonText: messageUtility.getMessage('I-000-011'),
      },
    });
  };

  /**
   * APIのエラーメッセージダイアログを表示する
   * @param {object} response  APIからのレスポンス
   * */
  showErrorMessageDialog = response => {
    const message = extractErrorMessage(response);
    if (isCcusJigyousyaNotConnectedError(message)) {
      this.setState({
        dialogStatus: DIALOG_STATUS.ccusConnectErrorDialogEnabled.id,
      });
      return;
    }
    this.setState({
      dialogStatus: DIALOG_STATUS.otherErrorDialogEnabled.id,
      informationModal: {
        ...this.state.informationModal,
        title: null,
        message: replaceTagInErrorMessage(message),
        buttonText: messageUtility.getMessage('I-000-017'),
      },
    });
  };

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    this.setFetchCcusWorkersDataFlag(false);
    this.setState({
      dialogStatus: DIALOG_STATUS.disabled.id,
      informationModal: {
        ...this.state.informationModal,
        title: null,
        message: null,
        buttonText: null,
      },
    });
  };

  /**
   * ダイアログを閉じる
   * */
  closeCcusFetchCompleteDialog = async () => {
    let state = { ...this.state };
    state = await this.fetchWorkerInfo(state);

    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.title = null;
    state.informationModal.message = null;
    state.informationModal.buttonText = null;

    this.setState(state, () => {
      this.setFetchCcusWorkersDataFlag(false);
      EventMg.trigger(EventType.FETCH_CCUS_INFO);
    });
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * タブを変更する直前に実行する
   */
  beforeChangeValidTab = selectedTabId => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.setState({
          dialogConfirmMoveTabId: selectedTabId,
          dialogStatus: DIALOG_STATUS.leaveThisPageDialogEnabled.id,
        });
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        _urlParamManager.setMaster('WorkerConfirm', {
          state: {
            id: `${getTabNameWorkerTabId(selectedTabId)},${
              this.props.workerId
            }`,
          },
        });

        this.setState({
          selectedTabId,
        });
        break;
      default:
        break;
    }
  };

  /**
   * 「CCUSから情報を取得」ボタン連打防止フラグに値をセット
   * */
  setFetchCcusWorkersDataFlag = value => {
    this.fetchCcusWorkersDataFlag = value;
  };

  renderDescription = () => {
    const { isOneOwnerCompany, totalWorkers } = this.state;

    if (isOneOwnerCompany && totalWorkers >= 1) {
      return (
        <Description type='primary'>
          <ul className='Description__content-header'>
            <li>
              「基本情報」以外のタブについては、基本情報の登録が完了してから操作が可能になります。
            </li>
            <li>
              この協力会社は一人親方に設定されており、すでに登録済みの作業員が
              {totalWorkers}名います。
            </li>
          </ul>
          <span className='clickable-text' onClick={this.redirectToCompanyPage}>
            会社情報画面
          </span>
          の一人親方の区分の設定がお間違いないか確認ください。
        </Description>
      );
    }

    return (
      <Description type='primary'>
        「基本情報」以外のタブについては、基本情報の登録が完了してから操作が可能になります。
      </Description>
    );
  };

  redirectToCompanyPage = () => {
    _masterSlideLoader.show('CompanyPreview', {
      state: { id: this.props.selectCompanyId },
    });
  };

  render() {
    // ios-safariだとツールバー分の高さがある為、考慮する
    // 後々ブラッシュアップが必要
    const contructioSlideViewBodyHeight = safariOnIosCheck()
      ? 'calc(100vh - 115px)'
      : 'calc(100vh - 84px)';
    const title = `作業員${this.props.pageStatus.EDIT_MODE ? '編集' : '登録'}`;
    let iconType = '';
    let inconsistencyStatusText = '';
    if (
      this.props.pageStatus !== WORKER_PAGE_STATUS.NEW &&
      isPartnerRoleId(this.state.roleId)
    ) {
      if (
        this.state.workerInfo.rank_consistency_status ===
        RANK_CONSISTENCY_STATUS.NOT_MATCHING.value
      ) {
        iconType = 'warning';
        inconsistencyStatusText = messageUtility.getMessage('W-000-017');
      } else if (
        this.state.workerInfo.rank_consistency_status ===
        RANK_CONSISTENCY_STATUS.UN_CONFIRM.value
      ) {
        iconType = 'caution';
        inconsistencyStatusText = messageUtility.getMessage('W-000-018');
      }
    }
    const roanToChoseiFlg = this.state.roanToChoseiFlg;

    return (
      <div
        id='slide-view'
        className={`${styles.workerForm} contruction-slide-view show`}
      >
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={
              <div>
                <span className='worker__title'>
                  {this.state.selectCompanyName}
                </span>
                <span className='worker__title'>{title}</span>
                {this.state.showWorkerName === true && (
                  <span className='worker__title'>
                    {this.state.workerInfo.name_sei +
                      this.state.workerInfo.name_mei}
                  </span>
                )}
              </div>
            }
            onClose={this.handlerMoveToBackPage}
          />
          <div
            className='contruction-slide-view__body'
            style={{ height: contructioSlideViewBodyHeight }}
          >
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <WorkerTab
                  roleId={this.state.roleId}
                  selectTabId={this.state.selectedTabId}
                  companyId={this.props.selectCompanyId}
                  iconTypeInconsistencyStatus={iconType}
                  inconsistencyStatusText={inconsistencyStatusText}
                  workerId={this.props.workerId}
                  onClick={(event, tabId) => {
                    this.beforeChangeValidTab(tabId);
                  }}
                />
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                {this.state.selectedTabId === WORKER_TAB.WORKER_INFO.ID && (
                  <WorkerInfo
                    companyId={this.props.selectCompanyId}
                    workerId={this.props.workerId}
                    pageStatus={this.props.pageStatus}
                    description={
                      this.props.pageStatus.ID ===
                        WORKER_PAGE_STATUS.NEW.ID && (
                        <div
                          style={{
                            maxWidth: '960px',
                            marginBottom: '24px',
                          }}
                        >
                          {this.renderDescription()}
                        </div>
                      )
                    }
                    isAgencyRegister={this.state.isAgencyRegister}
                    isCcusConnectSuccess={this.state.isAlreadyCcusConnect}
                    callFetchCcusWorkersData={this.fetchCcusWorkersData}
                    ccusWorker={this.state.ccusWorker}
                    linkedToCcusDate={this.state.workerInfo.linked_to_ccus_date}
                    isLinkedUser={this.state.isLinkedUser}
                    // BLDE_V2-50623 CCUS事業者は連携されているかどうかの情報
                    isCcusJigyousyaConnected={
                      this.state.isCcusJigyousyaConnected
                    }
                    agencyInfo={this.state.agencyInfo}
                    roanToChoseiFlg={roanToChoseiFlg}
                    selectCompanyName={this.state.selectCompanyName}
                    ccusJigyousyaId={this.state.ccusJigyousyaId}
                  />
                )}
                {this.state.selectedTabId === WORKER_TAB.WORKER_IMAGE.ID && (
                  <WorkerImage
                    companyId={this.props.selectCompanyId}
                    workerId={this.props.workerId}
                    pageStatus={this.props.pageStatus}
                    roanToChoseiFlg={roanToChoseiFlg}
                  />
                )}
                {this.state.selectedTabId ===
                  WORKER_TAB.WORKER_SAFETY_BASIC_INFO.ID && (
                  <WorkerSafetyBasicInfo
                    companyId={this.props.selectCompanyId}
                    workerId={this.props.workerId}
                    pageStatus={this.props.pageStatus}
                    isAlreadyCcusConnect={this.state.isAlreadyCcusConnect}
                    isAgencyRegister={this.state.isAgencyRegister}
                    linkedToCcusDate={this.state.workerInfo.linked_to_ccus_date}
                    isOverSixteen={this.state.workerInfo.isOverSixteen}
                    //  BLDE_V2-50226 CCUS事業者IDは削除されたかどうかの情報
                    isCcusJigyousyaDeleted={
                      this.state.workerInfo.ccus_jigyousya_deleted_flag
                    }
                    // BLDE_V2-50623 CCUS事業者は連携されているかどうかの情報
                    isCcusJigyousyaConnected={
                      this.state.isCcusJigyousyaConnected
                    }
                    callFetchCcusWorkersData={this.fetchCcusWorkersData.bind(
                      this
                    )}
                    agencyInfo={this.state.agencyInfo}
                    isLinkedUser={this.state.isLinkedUser}
                    roanToChoseiFlg={roanToChoseiFlg}
                    ccusEngineerId={this.state.workerInfo.ccus_engineer_id}
                  />
                )}
                {this.state.selectedTabId === WORKER_TAB.JOB_LICENSE.ID && (
                  <JobLicense
                    companyId={this.props.selectCompanyId}
                    workerId={this.props.workerId}
                    pageStatus={this.props.pageStatus}
                    isAlreadyCcusConnect={this.state.isAlreadyCcusConnect}
                    isAgencyRegister={this.state.isAgencyRegister}
                    linkedToCcusDate={this.state.workerInfo.linked_to_ccus_date}
                    //  BLDE_V2-50226 CCUS事業者IDは削除されたかどうかの情報
                    isCcusJigyousyaDeleted={
                      this.state.workerInfo.ccus_jigyousya_deleted_flag
                    }
                    // BLDE_V2-50623 CCUS事業者は連携されているかどうかの情報
                    isCcusJigyousyaConnected={
                      this.state.isCcusJigyousyaConnected
                    }
                    callFetchCcusWorkersData={this.fetchCcusWorkersData.bind(
                      this
                    )}
                    agencyInfo={this.state.agencyInfo}
                    isLinkedUser={this.state.isLinkedUser}
                    roanToChoseiFlg={roanToChoseiFlg}
                    ccusEngineerId={this.state.workerInfo.ccus_engineer_id}
                  />
                )}
                {this.state.selectedTabId === WORKER_TAB.INSURANCE_INFO.ID && (
                  <InsuranceInfo
                    companyId={this.props.selectCompanyId}
                    workerId={this.props.workerId}
                    pageStatus={this.props.pageStatus}
                    isAlreadyCcusConnect={this.state.isAlreadyCcusConnect}
                    isAgencyRegister={this.state.isAgencyRegister}
                    linkedToCcusDate={this.state.workerInfo.linked_to_ccus_date}
                    workerBirthday={this.state.workerInfo.birthday}
                    //  BLDE_V2-50226 CCUS事業者IDは削除されたかどうかの情報
                    isCcusJigyousyaDeleted={
                      this.state.workerInfo.ccus_jigyousya_deleted_flag
                    }
                    // BLDE_V2-50623 CCUS事業者は連携されているかどうかの情報
                    isCcusJigyousyaConnected={
                      this.state.isCcusJigyousyaConnected
                    }
                    callFetchCcusWorkersData={this.fetchCcusWorkersData.bind(
                      this
                    )}
                    agencyInfo={this.state.agencyInfo}
                    isLinkedUser={this.state.isLinkedUser}
                    roanToChoseiFlg={roanToChoseiFlg}
                    ccusEngineerId={this.state.workerInfo.ccus_engineer_id}
                  />
                )}
                {this.state.selectedTabId === WORKER_TAB.ANAMNESES.ID && (
                  <Anamneses
                    companyId={this.props.selectCompanyId}
                    workerId={this.props.workerId}
                    pageStatus={this.props.pageStatus}
                    isAlreadyCcusConnect={this.state.isAlreadyCcusConnect}
                    isAgencyRegister={this.state.isAgencyRegister}
                    linkedToCcusDate={this.state.workerInfo.linked_to_ccus_date}
                    callFetchCcusWorkersData={this.fetchCcusWorkersData.bind(
                      this
                    )}
                    roanToChoseiFlg={roanToChoseiFlg}
                  />
                )}
                {this.state.selectedTabId ===
                  WORKER_TAB.MEDICAL_EXAMINATION.ID && (
                  <MedicalExamination
                    companyId={this.props.selectCompanyId}
                    workerId={this.props.workerId}
                    pageStatus={this.props.pageStatus}
                    isAlreadyCcusConnect={this.state.isAlreadyCcusConnect}
                    isAgencyRegister={this.state.isAgencyRegister}
                    linkedToCcusDate={this.state.workerInfo.linked_to_ccus_date}
                    //  BLDE_V2-50226 CCUS事業者IDは削除されたかどうかの情報
                    isCcusJigyousyaDeleted={
                      this.state.workerInfo.ccus_jigyousya_deleted_flag
                    }
                    // BLDE_V2-50623 CCUS事業者は連携されているかどうかの情報
                    isCcusJigyousyaConnected={
                      this.state.isCcusJigyousyaConnected
                    }
                    callFetchCcusWorkersData={this.fetchCcusWorkersData.bind(
                      this
                    )}
                    agencyInfo={this.state.agencyInfo}
                    isLinkedUser={this.state.isLinkedUser}
                    roanToChoseiFlg={roanToChoseiFlg}
                    ccusEngineerId={this.state.workerInfo.ccus_engineer_id}
                  />
                )}
                {this.state.selectedTabId === WORKER_TAB.URGENCY_CONTACT.ID && (
                  <UrgencyContact
                    companyId={this.props.selectCompanyId}
                    workerId={this.props.workerId}
                    pageStatus={this.props.pageStatus}
                    isAlreadyCcusConnect={this.state.isAlreadyCcusConnect}
                    isAgencyRegister={this.state.isAgencyRegister}
                    linkedToCcusDate={this.state.workerInfo.linked_to_ccus_date}
                    //  BLDE_V2-50226 CCUS事業者IDは削除されたかどうかの情報
                    isCcusJigyousyaDeleted={
                      this.state.workerInfo.ccus_jigyousya_deleted_flag
                    }
                    callFetchCcusWorkersData={this.fetchCcusWorkersData.bind(
                      this
                    )}
                    // BLDE_V2-50623 CCUS事業者は連携されているかどうかの情報
                    isCcusJigyousyaConnected={
                      this.state.isCcusJigyousyaConnected
                    }
                    agencyInfo={this.state.agencyInfo}
                    isLinkedUser={this.state.isLinkedUser}
                    roanToChoseiFlg={roanToChoseiFlg}
                    ccusEngineerId={this.state.workerInfo.ccus_engineer_id}
                  />
                )}
                {this.state.selectedTabId ===
                  WORKER_TAB.TRAINING_COMMENDATION.ID && (
                  <TrainingCommendation
                    companyId={this.props.selectCompanyId}
                    workerId={this.props.workerId}
                    pageStatus={this.props.pageStatus}
                    isAlreadyCcusConnect={this.state.isAlreadyCcusConnect}
                    isAgencyRegister={this.state.isAgencyRegister}
                    linkedToCcusDate={this.state.workerInfo.linked_to_ccus_date}
                    //  BLDE_V2-50226 CCUS事業者IDは削除されたかどうかの情報
                    isCcusJigyousyaDeleted={
                      this.state.workerInfo.ccus_jigyousya_deleted_flag
                    }
                    // BLDE_V2-50623 CCUS事業者は連携されているかどうかの情報
                    isCcusJigyousyaConnected={
                      this.state.isCcusJigyousyaConnected
                    }
                    callFetchCcusWorkersData={this.fetchCcusWorkersData.bind(
                      this
                    )}
                    agencyInfo={this.state.agencyInfo}
                    isLinkedUser={this.state.isLinkedUser}
                    roanToChoseiFlg={roanToChoseiFlg}
                    ccusEngineerId={this.state.workerInfo.ccus_engineer_id}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* CCUS技能者情報取得成功した時のメッセージ */}
        <Information
          rootClassName={styles.fetchCompleteDialog}
          visible={[DIALOG_STATUS.ccusFetchCompleteDialogEnabled.id].includes(
            this.state.dialogStatus
          )}
          title={this.state.informationModal.title}
          message={this.state.informationModal.message}
          buttonText={this.state.informationModal.buttonText}
          onClose={this.closeCcusFetchCompleteDialog}
        />

        {/* CCUS技能者情報取得エラーが発生した時のメッセージ */}
        <Information
          rootClassName={styles.fetchCompleteDialog}
          visible={[DIALOG_STATUS.otherErrorDialogEnabled.id].includes(
            this.state.dialogStatus
          )}
          title={this.state.informationModal.title}
          message={this.state.informationModal.message}
          buttonText={this.state.informationModal.buttonText}
          onClose={this.closeDialog}
          flexMessage={true}
          tabFocus
        />

        <Information
          rootClassName={styles.ccusConnectErrorDialog}
          visible={[DIALOG_STATUS.ccusConnectErrorDialogEnabled.id].includes(
            this.state.dialogStatus
          )}
          title={messageUtility.getMessage('I-000-222')}
          message={
            <CcusConnectErrorDialog
              isAgencyRegister={this.state.isAgencyRegister}
            />
          }
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={this.closeDialog}
          multilineText={true}
        />

        {/* CCUS通信中のダイアログ */}
        <CommonModal
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.ccusConnectingDialogEnabled.id
          }
        >
          <CcusConnectingDialog />
        </CommonModal>

        {/* 『X』ボタンをクリックした時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={this.handlerBackToPage}
          onCancel={this.closeDialog}
        />

        {/* 編集画面でタブを遷移する時に表示する確認ダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => {
            masterSlideLoader.show('WorkerConfirm', {
              state: {
                id: `${getTabNameWorkerTabId(
                  this.state.dialogConfirmMoveTabId
                )},${this.props.workerId}`,
              },
            });
          }}
          onCancel={this.closeDialog}
        />
      </div>
    );
  }
}

const CcusConnectErrorDialog = ({ isAgencyRegister }) => {
  const prefix = isAgencyRegister ? <span className='bold'>代行先の</span> : '';
  const href = isAgencyRegister
    ? ZENDESK_URL_GUIDE.AGENCY_CCUS_CONNECT_WARNING
    : ZENDESK_URL_GUIDE.CCUS_CONNECT_WARNING;
  return (
    <div>
      <p>CCUS連携に失敗しました。</p>
      <br />
      <p>{prefix}CCUS連携に必要な初期設定が完了していません。</p>
      <p>
        {prefix}会社情報のCCUS連携情報を入力し、再度CCUS連携を行ってください。
      </p>
      <br />
      <p>
        {prefix}CCUS連携の初期設定の詳細は
        <a
          className='clickable-text'
          href={href}
          target='_blank'
          rel='noreferrer noopener'
        >
          こちら
        </a>
        をご確認ください。
      </p>
    </div>
  );
};

/**
 * 新規作成フォーム
 */
export class WorkerNew extends React.Component {
  render() {
    return (
      <WorkerForm
        pageStatus={WORKER_PAGE_STATUS.NEW}
        selectedTabId={WORKER_TAB.WORKER_INFO.ID}
        selectCompanyId={SessionStorageService.getSessionSelectedPartnerCompanyId()}
      />
    );
  }
}

/**
 * 詳細フォーム
 */
export class WorkerConfirm extends React.Component {
  render() {
    const [selectedTagName, workerId] = this.props.view.state.id.split(',');
    const selectedTabId =
      getIdWorkerTabTabName(selectedTagName) || WORKER_TAB.WORKER_INFO.ID;

    return (
      <WorkerForm
        workerId={workerId}
        pageStatus={WORKER_PAGE_STATUS.CONFIRM}
        selectedTabId={selectedTabId}
        selectCompanyId={SessionStorageService.getSessionSelectedPartnerCompanyId()}
      />
    );
  }
}

/**
 * 編集フォーム
 */
export class WorkerEdit extends React.Component {
  render() {
    const [selectedTagName, workerId] = this.props.view.state.id.split(',');
    const selectedTabId =
      getIdWorkerTabTabName(selectedTagName) || WORKER_TAB.WORKER_INFO.ID;

    return (
      <WorkerForm
        workerId={workerId}
        pageStatus={WORKER_PAGE_STATUS.EDIT}
        selectedTabId={selectedTabId}
        selectCompanyId={SessionStorageService.getSessionSelectedPartnerCompanyId()}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/WorkerForm.jsx